import React from 'react';
import PropTypes from 'prop-types';

// @todo AM-5946 - abstract styles from parent components into a local styles.scss file
import '~shared/components/react/EventCard/styles.scss';
import '~shared/components/react/EventDescription/styles.scss';

const EventStatusInplay = ({
    status = '',
    isInplay,
    extraInfo,
    categorySlug,
    cssClasses = 'event-description__status--extra-info',
}) => {
    if (!isInplay || !status) {

        return null;
    }

    let extraStatusText = '';

    if (extraInfo && categorySlug === 'esoccer') {
        /// GTP eSoccer match length
        const { total_periods: totalPeriods = '', period_length: periodLength = '' } = extraInfo;
        extraStatusText = totalPeriods && periodLength
            ? `${totalPeriods * periodLength}:00`
            : '';
    }

    // status can be empty string
    if (!extraStatusText || !status) {

        return <>{status}</>;
    }

    return <>
        {status}
        <span className={cssClasses}> / {extraStatusText}</span>
    </>;
};

EventStatusInplay.propTypes = {
    status: PropTypes.string,
    isInplay: PropTypes.bool.isRequired,
    extraInfo: PropTypes.shape({
        total_periods: PropTypes.string,
        period_length: PropTypes.string,
    }),
    categorySlug: PropTypes.string,
    cssClasses: PropTypes.string,
};

export default EventStatusInplay;
